// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PackActiveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Toggle-active request for a credit pack.
 *
 * Required fields:
 *   active (int) — 0 or 1
 */
import { registerContract } from './validate'

export interface AiCredits_PackActiveInput {
active: number
}

registerContract('AiCredits_PackActiveInput', {
  active: { type: 'number',  required: true },
})
